import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoginServicesService } from '../shared/services/login-services.service';
// import * as $ from 'jquery';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from '../shared/services/app.service';
declare var $: any;
@Component({
  selector: 'app-confirmregister',
  templateUrl: './confirmregister.component.html',
  styleUrls: ['./confirmregister.component.scss']
})
export class ConfirmregisterComponent implements OnInit {
  confirmMsgShow = false;
  verifyUsrID: any;
  usrVerified: any;
  groupToken: any;
  isOrgDisabled: any;
  language = 'en';
  languages = [
    { short: 'en', fullform: 'English' },
    { short: 'jp', fullform: 'Japanese' },
  ];
  userID: any;
  toastMsg: any;
  constructor(
    public translate: TranslateService,
    private router: Router,
    private loginService: LoginServicesService,
    private cookieService: CookieService,
    private AppService: AppService
  ) {
    translate.setDefaultLang('en');
    this.cookieService.delete('language');
    this.cookieService.set('language', this.language);
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|jp/) ? browserLang : 'en');
  }

  ngOnInit(): void {
    var uri = window.location.toString();
    if (uri.indexOf("?") > 0) {
      var queryStr = decodeURIComponent(window.location.href);
      var qStrData = queryStr.split("?")[1].split("=")[0];
      var qStrData1 = queryStr.split("?")[1].split("=")[1];
      if (qStrData1.indexOf("&expirylink") != -1) {
        qStrData1 = qStrData1.split("=")[0].split("&expirylink")[0];
      }
      // if (queryStr.indexOf("&expirylink") != -1) {
      //   let qStrData2 = queryStr.split("&expirylink")[1].split("=")[1];
      // }
      if (queryStr.indexOf("&") > 0) {
        let qStrVal = queryStr.split("?")[1].split("=")[1].split("&")[0];
        let qStrData1 = queryStr.split("&")[1].split("=")[1];
        if (qStrVal) {
          if (qStrData == 'id') {
            this.verifyUsrID = qStrVal;
            this.verifyEmailLink();
          } else if (qStrData == 'token') {
            $('#emailInputField').hide();
            $('#groupInputField').hide();
            this.usrVerified = 1;
            this.groupToken = qStrVal;
            // register.organization = qStrData1;
            this.isOrgDisabled = true;
          } else if (qStrData == 'userId') {
            this.userID = qStrVal;
          }
        }
      } else {
        if (qStrData == 'id') {
          this.verifyUsrID = qStrData1;
          this.verifyEmailLink();
        } else if (qStrData == 'userId') {
          this.userID = qStrData1;
        }
      }
      // console.log("1", this.userID);
      // console.log(this.verifyUsrID);
    }
  }

  updateLanguage(lang: any) {
    this.cookieService.delete('language');
    this.cookieService.set('language', lang);
  }
  verifyEmailLink() {
    if (this.verifyUsrID != "" && this.verifyUsrID != undefined && this.verifyUsrID != null) {
      var obje = {
        'link': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.IjIwMTktMTItMTFUMDk6MzI6NDQuMTIyWiI.qF4qvjCHxjFLUpkrq4NEyp_ysq8FyKpV90TKn49NXd4',
        'registerRefId': this.verifyUsrID
      }
      this.loginService.verifyEmailExpiryLink(obje)
        .subscribe(
          (response: any) => {
            if (response.message) {
              this.confirmMsgShow = true;
              // Array used while adding Demo app to Server DB (Always take lates data from Demo app Invites array)
              // var invitesArray = response.invites;
              // For Demo App
              //   var invitesArray = ["5e29bd1e3d0de84540e91621","5e621a9a38e06776ee8a612f","5ea6d483e990794c35b0e42c","5f322db4e997c877a07e24b8","5f322f2ee997c877a07e24be",
              // "5f32303ee997c877a07e24c4","5f3230f4e997c877a07e24ca","5f323366e997c877a07e24d0","5f3bb8d8a3d6fc22c6ea782c","5f477698469c317d6b7fdda9"];
              // invitesArray.push(this.verifyUsrID);
              // console.log(invitesArray);
              this.emailVerify(this.verifyUsrID);
              // triggerToast(response.data);
              // $scope.userID = '';
              // setTimeout(function () { window.location.href = "#!/login" }, 3000);
              this.toastMsg = "Email verified successfully..";
            } else if (response.statusCode === 401) {
              this.confirmMsgShow = true;
              this.triggerToast(this.AppService.getResourceText("B018"));
            }
          },
          // (response: any) => {
          //   this.triggerToast(this.AppService.getResourceText("B002"));
          // }
        );
    }
  }
  emailVerify(id: any) {
    let emailId = { "id": id };
    this.loginService.emailVerification(emailId)
      .subscribe(
        (response: any) => {
          if (response.statusCode === 200) {
            this.confirmMsgShow = true;
            // triggerToast(AppService.getResourceText("B001"));
          }
        },
        // function onError(response: any) => { 
        //   // triggerToast(AppService.getResourceText("B002"));
        // });
      )
  }
  triggerToast(message: string) {
    this.toastMsg = message;
    $('#snackbar').html(message);
    var x: any = document.getElementById('snackbar');
    x.className = 'show';
    setTimeout(() => {
      x.className = x.className.replace('show', '');
    }, 3000);
  }
}
